import React from "react";
import { useDispatch } from "react-redux";
import { sidebarOpen } from "../../../../redux/reducers/sidebarReducer";
// import { DASHBOARD_SIDEBAR_TYPES } from "../DASHBOARD_SIDEBAR_TYPES";
import { Button } from "@mui/material";
import { DASHBOARD_SIDEBAR_TYPES } from "../DashboardSidebar";
import { AddOutlined } from "@mui/icons-material";

const SidebarAddEntityButton = ({ children = "Add New Entity" }) => {
  const dispatch = useDispatch();

  const handleOnClick = () => {
    dispatch(
      sidebarOpen(
        DASHBOARD_SIDEBAR_TYPES.ADD_ENTITY, // type
        // { loanId: "12345" }, // data
        // { source: "conditions-tab" }, // metadata
      ),
    );
  };

  return (
    <Button
      startIcon={<AddOutlined className="thin" />}
      onClick={handleOnClick}
    >
      {children}
    </Button>
  );
};

export default SidebarAddEntityButton;
